module.exports = (ProductsService, RESTService) ->
  'ngInject'
  (productId) ->
    RESTService.service('images', ProductsService.one(productId))
